<div class="py-4 container-fluid" style="padding-bottom: 50px !important">
  <div class="row">
    <div class="col-12">
      <h2 class="text-center">Wells Management</h2>
      {{selectedWellList}}
    </div>
  </div>
  <div class="d-flex justify-content-between flex-wrap-reverse mt-4">
    <div class="d-flex flex-wrap-reverse">
      <div class="dropdown mb-2">
        <button type="button" dropdownToggle class="btn btn-secondary dropdown-toggle" id="dropdownmenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions <span class="caret"></span></button>
        <ul class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownmenu1">
          <li><span class="dropdown-header" *ngIf="wellsSelectedCount <= 0">Please select well(s)</span> </li>
          <li><button class="dropdown-item" data-toggle="modal" [disabled]="wellsSelectedCount <= 0" (click)="multiWellFunc()" data-target="#editwellinfomodal">Edit Well(s)</button></li>
        </ul>
      </div>
      <span class="px-2"></span>
      <div class="mb-2">
        <button [disabled]="wellsSelectedCount != 1" (click)="goToCreateWellPage('editMode')" type="button" class="btn btn-primary "><span class='fas fa-user'></span> Edit Well Timeline </button>
      </div>
      <span class="px-2"></span>
      <div class="mb-2">
        <button *ngIf="wellsSelectedCount > 0" class="btn btn-primary" title="Click to filter selected wells" style="border-radius:50%;" (click)="filterSelectedWells()">{{wellsSelectedCount}}</button>
      </div>
      <span class="px-2"></span>
      <div class="mb-2">
        <button type="button" class="btn btn-link" title="Refresh well list" style="margin-right:15px;" [disabled]="loading" (click)="refresh()">
          <ng-container *ngIf="loading; else notLoading">
            <span role="status" class="spinner-border spinner-border-sm"></span>
          </ng-container>
          <ng-template #notLoading>
            <i class="fas fa-sync-alt"></i>
          </ng-template>
        </button>
      </div>
    </div>
    <div class="mb-2">
      <button class="btn btn-success" (click)="goToCreateWellPage('createMode')"><span class='fas fa-plus'></span> Create Well</button>
    </div>
  </div>

  <input type="text" [(ngModel)]="search" [disabled]="loading" autocomplete="off" (keyup)="pageChanged(1)" name="look" placeholder="Filter by WellID, Battery Name, etc..." class="form-control ng-pristine ng-valid ng-touch my-2 filter-input" />

  <div class="table-responsive rr-elevation-z2">
    <table class="table table-hover" style="width: 100%;">
      <thead>
        <tr class="usertablerow">
          <th scope="col" class=""> <input type="checkbox" id="MasterCheckBox" name="MasterCheckBox" [(ngModel)]="MasterCheckBox" class="master big-checkbox" (change)="selectAllClicked()"/></th>
          <th scope="col" class="">Field Name <i class="fas fa-sort" (click)="orderList('fieldName')"></i></th>
          <th scope="col" class="">Battery <i class="fas fa-sort" (click)="orderList('batteryName')"></i></th>
          <th scope="col" class="">Well Name <i class="fas fa-sort" (click)="orderList('wellName')"></i></th>
          <th scope="col" class="">Well ID <i class="fas fa-sort" (click)="orderList('wellID')"></i></th>
          <th scope="col" class="">Status <i class="fas fa-sort" (click)="orderList('currentStatusName')"></i></th>
          <th scope="col" class="">Lease <i class="fas fa-sort" (click)="orderList('leaseNumber')"></i></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="null!= wells && ((wells | wellfilter: search: dummbyValue)?.length == 0 && !loading); else displayWells">
          <tr>
            <td colspan="7" class="text-center"><em>No wells found</em></td>
          </tr>
        </ng-container>
        <ng-template #displayWells>
          <tr *ngFor="let well of wells | wellfilter :search: dummbyValue | paginate: config;let i  = index" scope="row">
            <td class="check"><input type="checkbox" class="big-checkbox ChildCheckBox" [(ngModel)]="well.isChecked" id="{{well.wellID}}" name="wellselect_{{well.fieldID}}{{well.wellID}}" (change)="wellSelected(well)" /></td>
            <td data-toggle="modal" data-target="#editwellinfomodal" (click)="callWellFunction(well)">{{well.fieldName}}</td>
            <td data-toggle="modal" data-target="#editwellinfomodal" (click)="callWellFunction(well)">{{well.batteryName}}</td>
            <td data-toggle="modal" data-target="#editwellinfomodal" (click)="callWellFunction(well)">{{well.wellName}}</td>
            <td data-toggle="modal" data-target="#editwellinfomodal" (click)="callWellFunction(well)">{{well.wellID}}</td>
            <td data-toggle="modal" data-target="#editwellinfomodal" (click)="callWellFunction(well)">{{well.currentStatusName}}  </td>
            <td data-toggle="modal" data-target="#editwellinfomodal" (click)="callWellFunction(well)">{{well.leaseNumber}}</td>
          </tr>
        </ng-template>
      </tbody>
    </table>

    <div class="text-center py-2" style="width:100%" *ngIf="loading">
      <div class="spinner-border py-1" style="width: 3rem; height: 3rem;" role="status"></div>
    </div>

    <div role="alert" *ngIf="null != wells && wells.length == 0 && !loading" class="alert alert-danger">
      There was an error getting the wells for {{company}}. Please try again or contact an admin.
    </div>

    <div class="d-flex justify-content-center flex-wrap align-items-center py-2">
      <pagination-controls (pageChange)="pageChanged($event);" [id]="config.id"
                           [maxSize]="maxSize"
                           [directionLinks]="directionLinks"
                           [autoHide]="autoHide"
                           [responsive]="responsive"
                           [previousLabel]="labels.previousLabel"
                           [nextLabel]="labels.nextLabel"
                           [screenReaderPaginationLabel]="labels.screenReaderPaginationLabel"
                           [screenReaderPageLabel]="labels.screenReaderPageLabel"
                           [screenReaderCurrentLabel]="labels.screenReaderCurrentLabel">
      </pagination-controls>
      <div>
        <select class="form-control form-control-sm" name="pageLimit" id="pageLimit" [(ngModel)]="config.itemsPerPage">
          <option [selected]="p == 10" value="10">10</option>
          <option [selected]="p == 25" value="25">25</option>
          <option [selected]="p == 50" value="50">50</option>
          <option [selected]="p == 100" value="100">100</option>
        </select>
      </div>
    </div>

  </div>
</div>

<div class="modal fade" id="editwellinfomodal" tabindex="-1" role="dialog" aria-labelledby="editwellinfomodal" aria-hidden="true" (blur)="modalLostFocus('editwellinfomodal',editWellInfoFrm)">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="editwellinfomodallabel">
          Edit Well<span *ngIf="multiWell">s</span> Info
        </h5>
        <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close" (click)="resetForm('editwellinfomodal',editWellInfoFrm)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <form [formGroup]="editWellInfoFrm" (ngSubmit)="editWellInfo(editWellInfoFrm)">
        <div class="modal-body">
          <div *ngIf="wellInfoMessage" class="{{wellInfoAlertClass}} | sanitize" role="alert" id="wellInfoMessageBox">
            <strong *ngIf="wellInfoAlertClass != 'alert alert-success'">Attention!</strong>
            {{wellInfoMessage}}
          </div>
          <div *ngIf="displayWarning()" class="alert alert-warning" role="alert" id="wellInfoMessageBox">
            <strong>Attention!</strong> "Due to a current Control Panel limitation,
            only one change operation can be made to a well on a single calendar day.
            You are attempting to make a subsequent change on a day where another change is present.
            In order to complete your requested operation, please contact Mi4 Support."
          </div>
          <div *ngIf="selectedWellDateString == 'N/A' || past30Days" class="alert alert-info" role="alert">
            Please contact <a href="mailto:support@mi4.com">support&#64;mi4.com</a> if  edits need to go back more than 30 days.
          </div>

          <div class="form-row" *ngIf="multiWell">
            <div class="form-group col-md-6">
              <label>Wells Selected</label>
              <input class="form-control" type="number" disabled [ngModel]="wellsSelectedCount" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="form-group col-md-6" *ngIf="sameField">
              <label>Field Name</label>
              <input class="form-control" type="text" disabled [ngModel]="field" [ngModelOptions]="{standalone: true}" />
            </div>
          </div>

          <div class="form-row" *ngIf="!multiWell">
            <div class="form-group col-md-6">
              <label>Well Name</label>
              <input class="form-control" type="text" disabled [ngModel]="selectedWell.wellName" [ngModelOptions]="{standalone: true}" />

            </div>
            <div class="form-group col-md-6">
              <label>Well ID</label>
              <input class="form-control" type="text" disabled [ngModel]="selectedWell.wellID" [ngModelOptions]="{standalone: true}" />
            </div>
          </div>
          <div class="form-row" *ngIf="!multiWell">
            <div class="form-group col-md-6">
              <label>Last Effective Date</label>
              <input class="form-control" type="text" disabled [ngModel]="selectedWellDateString" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="form-group col-md-6">
              <label>Field Name</label>
              <input class="form-control" type="text" disabled [ngModel]="field" [ngModelOptions]="{standalone: true}" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="date1">Effective Date <small class="text-muted" *ngIf="hideChangeIndicator('EffectiveDate')">Changed</small></label>
              <p-calendar id="mydate" formControlName="EffectiveDate" (onSelect)="returnSelectedWellDate()" (onShow)="onCalendarOpen()" [minDate]="dateSelectOptions.minDate" [maxDate]="dateSelectOptions.maxDate" [showIcon]="true" [iconDisplay]="'input'" required></p-calendar>
              <div class="form-group alert alert-info" role="alert" *ngIf=" editWellInfoFrm.controls['EffectiveDate'].dirty &&  editWellInfoFrm.controls['EffectiveDate'].value == null ">
                Please select a valid effective date.
              </div>
            </div>
            <div class="form-group col-md-6">
              <label for="status">Status <small class="text-muted" *ngIf="hideChangeIndicator('StatusID')">Changed</small></label>
              <select name="StatusID" class="form-control" id="status" (change)="statusChanged()" formControlName="StatusID">
                <option *ngIf="multiWell" [value]="'noChange'" [selected]="multiWell">No Change</option>
                <option *ngFor="let stat of wellStatus" [value]="stat.id" [selected]="!multiWell ? stat.id === selectedWell.currentStatusID : null">
                  {{stat.name}}
                </option>
              </select>
              <div role="alert" class="alert alert-warning" *ngIf="editWellInfoFrm.controls['StatusID'].value != 'noChange' && null != editWellInfoFrm.controls['StatusID'].value && editWellInfoFrm.controls['StatusID'].dirty && ((null != selectedWell && editWellInfoFrm.controls['StatusID'].value != selectedWell.currentStatusID) ||(null == selectedWell )) && editWellInfoFrm.controls['StatusID'].value !='6' && editWellInfoFrm.controls['EffectiveDate'].valid">
                <input type="checkbox" class="big-checkbox" [hidden]="!multiWell && fieldDateRangeStartString == 'n/a'" name="hydrateCheck" formControlName="checkHydrate" />
                <div style="display:inline-block;" *ngIf="editWellInfoFrm.controls['StatusID'].value == '1' && multiWell ">
                  Create the well data up to available dates for each well.
                </div>
                <div style="display:inline-block;" *ngIf="editWellInfoFrm.controls['StatusID'].value == '1' && !multiWell && fieldDateRangeStartString != 'n/a'">
                  Create the well data from {{fieldDateRangeStartString}} to {{fieldDateRangeEndString}}?
                </div>
                <div style="display:inline-block;" *ngIf="editWellInfoFrm.controls['StatusID'].value == '1' && !multiWell && fieldDateRangeStartString == 'n/a'">
                  No available dates for creation
                </div>
                <div style="display:inline-block;" *ngIf="editWellInfoFrm.controls['StatusID'].value != '1' && editWellInfoFrm.controls['StatusID'].value != '6' && multiWell">
                  Delete the well data up to available dates for each well.
                </div>
                <div style="display:inline-block;" *ngIf="editWellInfoFrm.controls['StatusID'].value != '1' && editWellInfoFrm.controls['StatusID'].value != '6' && !multiWell  && fieldDateRangeStartString != 'n/a'">
                  Delete the well data from {{fieldDateRangeStartString}} to {{fieldDateRangeEndString}}?
                </div>
                <div style="display:inline-block;" *ngIf="editWellInfoFrm.controls['StatusID'].value != '1' && editWellInfoFrm.controls['StatusID'].value != '6' && !multiWell  && fieldDateRangeStartString == 'n/a'">
                  No available dates for deletion
                </div>
              </div>
              <div class="form-group alert alert-danger" role="alert" *ngIf="batteryWarning && multiWell && !sameField">
                One or more of the selected wells have no battery, this status is not valid.
              </div>
            </div>
            <div class="form-group col-md-6" *ngIf=" !multiWell || sameField">
              <label for="battery">Battery <small class="text-muted" *ngIf="hideChangeIndicator('BatteryID') ">Changed</small></label>
              <select name="BatteryID" class="form-control" id="battery" formControlName="BatteryID" (change)="batteryChanged()">

                <option *ngIf="multiWell" [value]="'noChange'" [selected]="multiWell">No Change</option>
                <option *ngIf="editWellInfoFrm.controls['StatusID'].value == '6'" [value]="null">None</option>
                <option *ngFor="let batt of wellBatteries" [value]="batt.batteryID" [selected]="batterySelected(batt.batteryID)">
                  {{batt.batteryName}}
                </option>
              </select>
              <div class="form-group alert alert-danger" role="alert" *ngIf="batteryWarning && multiWell">
                One or more of the selected wells have no battery, please select a battery to continue.
              </div>
              <div class="form-group alert alert-danger" role="alert" *ngIf="(this.editWellInfoFrm.controls['BatteryID'].value == null && this.editWellInfoFrm.controls['StatusID'].value != 6) && multiWell">
                The current selection of "None" is not allowed with any status except for drilling.
              </div>

            </div>
            <div class="form-group col-md-6" *ngIf=" (!multiWell || sameField ) && !oneWellIsSWD">
              <label for="gasfacility">Gas Facility <small class="text-muted" *ngIf="hideChangeIndicator('GasFacilityID') ">Changed</small></label>
              <select name="GasFacilityID" class="form-control" id="gasfacility" formControlName="GasFacilityID">
                <option [value]="null">None</option>
                <option *ngIf="multiWell" [value]="'noChange'" [selected]="multiWell">No Change</option>
                <option *ngFor="let gas of wellGasFacilities" [value]="gas.gasFacilityID" [selected]="gasFacilitySelected(gas.gasFacilityID)">
                  {{gas.gasFacilityName}}
                </option>
              </select>
            </div>
            <div class="form-group alert alert-info" role="alert" *ngIf="oneWellIsSWD">
              The gas facility is disabled due to one or more wells being SWDs.
            </div>

            <div class="form-group alert alert-info" role="alert" *ngIf=" !sameField && multiWell">
              The battery, gas facility and SWD selections are unavailable due to wells not being in the same field.
            </div>
          </div>

          <div class="form-row" *ngIf=" (!multiWell || sameField ) && !oneWellIsSWD">
            <div class="form-group col-md-12">
              <label for="swdid">SWD <small class="text-muted" *ngIf="hideChangeIndicator('swdid') ">Changed</small></label>
              <select name="swdid" class="form-control" id="swdid" formControlName="swdid">
                <option [value]="null">None</option>
                <option *ngIf="multiWell" [value]="'noChange'" [selected]="multiWell">No Change</option>
                <option *ngFor="let swd of wellSWDList" [value]="swd.wellID" [selected]="swdSelected(swd.wellID)">
                  {{swd.wellName}}
                </option>
              </select>

            </div>

          </div>
          <div class="form-group alert alert-info" role="alert" *ngIf="oneWellIsSWD">
            The SWD is disabled due to one or more wells being SWDs.
          </div>

          <div class="card mb-4">
            <div class="card-header">
              Wellhead
            </div>
            <div class="card-body" *ngIf="editWellInfoFrm.controls['swdid'].enabled && !multiWell">
              <div class="form-group row">
                <div class="col-md-6">
                  <label for="gasOutMeterDiameter" class="float-left">Meter Diameter <small class="text-muted" *ngIf="hideChangeIndicator('gasOutMeterDiameter')">Changed</small></label><small hidden id="gasOutDiameterLoader"><span class="spinner-border spinner-border-sm"></span></small>
                  <select name="gasOutMeterDiameter" class="form-control" id="gasOutMeterDiameter" (change)="setPlateDiameterDropDown(editWellInfoFrm.controls['gasOutMeterDiameter'].value, false,false)" formControlName="gasOutMeterDiameter">
                    <option [value]="null" selected [selected]="null == editWellInfoFrm.controls['gasOutMeterDiameter'].value">Make a selection</option>
                    <option *ngFor="let p of wellPlateInfo" [value]="p.plateDiameter">
                      {{p.plateDiameter}}
                    </option>
                  </select>
                  <div role="alert" class="alert alert-danger" *ngIf="null != editWellInfoFrm.controls['gasOutMeterDiameter'].value && null == editWellInfoFrm.controls['gasOutPlateSize'].value ">
                    Please select a Wellhead Gas Meter Plate Size
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="gasOutPlateSize" class="float-left">Meter Plate Size <small *ngIf="hideChangeIndicator('gasOutPlateSize')" class="text-muted">Changed</small><small hidden id="gasOutPlateLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
                  <select name="gasOutPlateSize" class="form-control" id="gasOutPlateSize" (change)="setPlateSizeCoef(editWellInfoFrm.controls['gasOutMeterDiameter'].value ,editWellInfoFrm.controls['gasOutPlateSize'].value, false)" formControlName="gasOutPlateSize">
                    <option [value]="null" [selected]="null == editWellInfoFrm.controls['gasOutPlateSize'].value">Make a selection</option>
                    <option *ngFor="let i of gasOutPlateSize" [value]=" i.plateSize">
                      {{i.plateSize}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="gasOutPlateCoefficient" class="float-left">Plate Coefficient <small *ngIf="hideChangeIndicator('gasOutPlateCoefficient')" class="text-muted">Changed</small><small hidden id="gasOutPlateCoefLoader"><span class="spinner-border spinner-border-sm"></span></small></label>
                    <input name="gasOutPlateCoefficient" class="form-control" formControlName="gasOutPlateCoefficient" disabled />
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="gasOutSpringSize" class="float-left">Spring Size <small *ngIf="hideChangeIndicator('gasOutSpringSize')" class="text-muted">Changed</small></label>
                  <input name="gasOutSpringSize" class="form-control" type="text" autocomplete="off" formControlName="gasOutSpringSize" />
                  <div class="alert alert-danger" role="alert" *ngIf="editWellInfoFrm.controls['gasOutSpringSize'].invalid  ">
                    {{invalidFloatMessage}}
                  </div>
                </div>

              </div>
            </div>

            <div class="form-group alert alert-info" role="alert" *ngIf="editWellInfoFrm.controls['swdid'].disabled || multiWell">
              <p>The wellhead plate size is disabled due to the well being an SWD and/or multiple wells being selected</p>
            </div>



          </div>

          <div class="card mb-4">
            <div class="card-header">
              Injection
            </div>
            <div class="card-body" *ngIf="editWellInfoFrm.controls['swdid'].enabled && !multiWell">
              <div class="form-group row">
                <div class="col-md-6">
                  <label for="gasInMeterDiameter" class="float-left">Meter Diameter <small class="text-muted" *ngIf="hideChangeIndicator('gasInMeterDiameter')">Changed</small></label><small hidden id="gasInDiameterLoader"><span class="spinner-border spinner-border-sm"></span></small>
                  <select name="gasInMeterDiameter" class="form-control" id="gasInMeterDiameter" (change)="setPlateDiameterDropDown(editWellInfoFrm.controls['gasInMeterDiameter'].value, true,false)" formControlName="gasInMeterDiameter">
                    <option [value]="null" selected [selected]="null == editWellInfoFrm.controls['gasInMeterDiameter'].value">Make a selection</option>
                    <option *ngFor="let t of wellPlateInfo" [value]="t.plateDiameter">
                      {{t.plateDiameter}}
                    </option>
                  </select>
                  <div role="alert" class="alert alert-danger" *ngIf="null != editWellInfoFrm.controls['gasInMeterDiameter'].value && null == editWellInfoFrm.controls['gasInPlateSize'].value">
                    Please select an Injection Gas Meter Plate Size
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="gasInPlateSize" class="float-left">Meter Plate Size <small class="text-muted" *ngIf="hideChangeIndicator('gasInPlateSize')">Changed</small></label>
                  <select name="gasInPlateSize" class="form-control" id="gasInPlateSize" (change)="setPlateSizeCoef(editWellInfoFrm.controls['gasInMeterDiameter'].value,editWellInfoFrm.controls['gasInPlateSize'].value, true)" formControlName="gasInPlateSize">
                    <option [value]="null" selected [selected]="null == editWellInfoFrm.controls['gasInPlateSize'].value">Make a selection</option>
                    <option *ngFor="let g of gasInPlateSize" [value]="g.plateSize">
                      {{g.plateSize}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label for="gasInPlateCoefficient" class="float-left">Plate Coefficient <small *ngIf="hideChangeIndicator('gasInPlateCoefficient')" class="text-muted">Changed</small><small hidden id="gasInPlateCoefLoader"><span class="spinner-border spinner-border-sm"></span></small> </label>
                  <input name="plateInSizeCoef" class="form-control" formControlName="gasInPlateCoefficient" disabled />
                </div>

                <div class="col-md-6">
                  <label for="gasInSpringSize" class="float-left"> Spring Size <small class="text-muted" *ngIf="hideChangeIndicator('gasInSpringSize')">Changed</small></label>
                  <input name="gasInSpringSize" class="form-control" type="text" autocomplete="off" formControlName="gasInSpringSize" />
                  <div class="alert alert-danger" role="alert" *ngIf="editWellInfoFrm.controls['gasInSpringSize'].invalid ">
                    {{invalidFloatMessage}}
                  </div>
                </div>


              </div>
            </div>

            <div class="form-group alert alert-info" role="alert" *ngIf="editWellInfoFrm.controls['swdid'].disabled || multiWell">
              <p>The injection plate size is disabled due to the well being an SWD and/or multiple wells being selected</p>
            </div>

          </div>

          <div class="form-row" *ngIf=" !multiWell">
            <div class="form-group  col-md-12">
              Is Gas Lift Well
              <span class="px-2"></span>
              <label class="switch">
                <input type="checkbox" id="wellModalGasLift" formControlName="isGasLiftWell">
                <span class="slider round"></span>
              </label>



            </div>
            <div class="form-group  col-md-6">
              <label for="newapinumber">API# <small class="text-muted" *ngIf="hideChangeIndicator('newapinumber')">Changed</small></label>
              <input name="newapinumber" class="form-control" type="text" autocomplete="off" formControlName="newapinumber" pattern="([A-Za-z0-9\-\_]+)" />
              <div role="alert" class="alert alert-danger" *ngIf="editWellInfoFrm.controls['newapinumber'].invalid">
                {{invalidAPIMessage}}
              </div>
            </div>
            <div class="form-group col-md-6">
              <label for="newleasenumber">Lease# <small class="text-muted" *ngIf="hideChangeIndicator('newleasenumber')">Changed</small></label>
              <input name="newleasenumber" class="form-control" type="text" autocomplete="off" formControlName="newleasenumber" pattern="([A-Za-z0-9\-\_]+)" />
              <div class="alert alert-danger" role="alert" *ngIf="editWellInfoFrm.controls['newleasenumber'].errors?.pattern">
                Lease # not valid.
              </div>
            </div>
            <div class="form-group  col-md-12">
              <label for="newserialnumber">Serial# <small class="text-muted" *ngIf="hideChangeIndicator('newserialnumber')">Changed</small></label>
              <input name="newserialnumber" class="form-control" type="text" autocomplete="off" formControlName="newserialnumber" pattern="([A-Za-z0-9\-\_]+)" />
              <div class="alert alert-danger" role="alert" *ngIf="editWellInfoFrm.controls['newserialnumber'].errors?.pattern">
                Serial # not valid.
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="newapinumber">Notes <small class="text-muted" *ngIf="hideChangeIndicator('notes')">Changed</small></label>
              <textarea name="notes" class="form-control" type="text" autocomplete="off" formControlName="notes"></textarea>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12" *ngIf="uneditedWellInfoList && multiWell">
              <table>
                <thead>
                  <tr>
                    <th>Well ID </th>
                    <th style="padding-left:10px;">Error </th>
                  </tr>
                </thead>
                <tr *ngFor="let well of uneditedWellInfoList">
                  <td>{{well.wellID}}</td>
                  <td style="padding-left:10px;">{{well.message}}</td>
                </tr>
              </table>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary pull-left" id="WellInfoCancel" data-dismiss="modal" (click)="resetForm('editwellinfomodal',editWellInfoFrm)">Cancel</button>
          <div class="loading-indicator login-btn-container" *ngIf="!submitted">
            <button type="submit" class="btn btn-primary" [disabled]="!editWellInfoFrm.valid || editWellInfoFrm.pristine || disableSubmit() || validPlateSize() || (multiWell && wellsSelectedCount <= 0 )">Submit Well Info</button>
          </div>
          <div class="loading-indicator login-btn-container" *ngIf="submitted">
            <button class="btn  btn-danger"><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span> Submitting...</button>
          </div>
        </div>

      </form>
    </div>
  </div>

</div>
